import { createRoot } from 'react-dom/client';
import React from "react";
import ProductCustomizer from "@root-components/ProductCustomizer.jsx";
import { Drawer } from "static.theme.js";
import { PDPTemplateSectionReplacement, ReplaceableSection } from './scripts/store/section-replacement.js';
import { attachWidgetRefereshEvents } from './scripts/store/yotpo.js';

// Extend the Drawer
class CustomizerDrawer extends Drawer {
  constructor(){
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    // for debuging
    this.debug = false;
    // this.variant = {
    //   handle: 'drawer-system-premium-accessory-pack-8-with-cabside-gap',
    //   variant_id: '42074091552834',
    // };
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("variant:add", this._onVariantAddedListener);
    this.cartDrawer = document.querySelector('.cart-drawer');
    if(this.debug){
      this.show();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("variant:add", this._onVariantAddedListener);
    this.root?.unmount();
  }
  show(){
    if(this.debug || this.variant){
      super.show();
      this.root = createRoot(customizerDrawer);
      this.root.render(<ProductCustomizer productHandle={this.variant?.handle} variantId={this.variant?.variant_id} drawerElement={this} />);
    }
  }
  _onVariantAdded(event){
    this.variant = event.detail.items[0];
    const customizerEnabled = event.detail.customizerEnabled;
  
    if(customizerEnabled){
      event.detail.blockCartDrawerOpening = true;
      this.cartDrawer.hide();
      this.show();
    }
  }
}

const customizerDrawer = document.createElement("customizer-drawer");
customizerDrawer.id = "customizer-drawer";
//customizerDrawer.setAttribute("tray-open", true);
customizerDrawer.classList.add("drawer", "drawer--md", "show-close-cursor")
document.body.appendChild(customizerDrawer);

window.customElements.define('customizer-drawer', CustomizerDrawer);
window.customElements.define('section-replacement', PDPTemplateSectionReplacement);
window.customElements.define('replaceable-section', ReplaceableSection);

attachWidgetRefereshEvents();